import { useState, useEffect, Dispatch, SetStateAction } from 'react';
import { flushSync } from 'react-dom';

type UseFieldResult<T> = [T, Dispatch<SetStateAction<T>>];

function useField<T = undefined>(): UseFieldResult<T | undefined>;
function useField<T>(syncState: T, deps?: any[]): UseFieldResult<T>;
function useField<T>(syncState: () => T, deps: any[]): UseFieldResult<T>;
function useField<T>(syncState: (prev: T) => T, deps: any[]): UseFieldResult<T>;
function useField<T = any>(...args: any[]) {
  const [syncState, deps] = args;
  const [state, setState] = useState<T>(syncState);

  useEffect(
    () => {
      queueMicrotask(() => flushSync(() => setState(syncState)));
    },
    deps || [syncState] // eslint-disable-line react-hooks/exhaustive-deps
  );

  return [state, setState];
}

export default useField;
